export { default } from './Loader';